<template>
    <div class="login-body">
        <div class="login-panel p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div class="p-mb-5">
                        <div class="p-d-flex p-jc-center p-mb-5"><img style="max-width: 20%" src="/assets/logo-highlight-common.svg" alt="yuzaner" /></div>

                        <h3 class="p-d-flex p-jc-center p-mt-2"><span>{{ $store.state.i18n.messageBundle?.password_reset?.title }}</span></h3>

                        <form @submit.prevent="onSubmit" class="p-my-5">
                            <div v-if="isRequestSuccess" class="p-fluid">
                                <div class="p-my-3">
                                    <InlineMessage severity="info">
                                        {{ $store.state.i18n.messageBundle?.password_reset?.email_reset_code_sent }}
                                    </InlineMessage>
                                    <Button class="p-button-primary p-mt-1" @click="gotoPasswordResetWithEmail()" :label="$store.state.i18n.messageBundle?.common?.proceed"></Button>
                                </div>
                            </div>
                            <div v-else class="p-fluid">
                                <div class="p-my-3">                                    
                                    <div>
                                        <label for="email" class="account-attr-font" :class="{ 'p-error': v$.email.$invalid && submitted }">
                                            <strong>{{ $store.state.i18n.messageBundle?.profile?.email }}</strong></label>
                                        <InputText id="email" 
                                            :placeholder="$store.state.i18n.messageBundle?.password_reset?.enter_registered_email" type="email" v-model="v$.email.$model" class="common-email-input email-input p-mt-2" :class="{ 'p-invalid': v$.email.$invalid && submitted }" />
                                    </div>
                                    <div>
                                        <small v-if="v$.email.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.profile?.email }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-my-1">
                                    <Button :disabled="isProcessing || v$.email.$invalid || submitted" class="p-button-primary" @click="sendResetPasswordRequest()" :label="$store.state.i18n.messageBundle?.password_reset?.email_reset_code_req"></Button>
                                </div>


                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">{{ $store.state.i18n.messageBundle?.password_reset?.cannot_find_registered_email }}</InlineMessage>
                                </div>

                            </div>
                        </form>
                        <hr />
                        <div class="p-mt-3">
                            <h5>{{ $store.state.i18n.messageBundle?.common?.useful_links }}</h5>
                            <div class="p-mb-3">
                                <a class="p-button-link" @click="gotoPasswordResetWithEmail()">&nbsp;<span class="pi pi-check-circle"></span>&nbsp;{{ $store.state.i18n.messageBundle?.password_reset?.email_reset_code_proceed }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a href="/#/login">&nbsp;<span class="pi pi-sign-in"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.useful_links?.login_with_email }}</a>
                            </div>
                        </div>
                        <div style="padding-bottom: 50px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AuthService from '../service/AuthService';
import UtilService from '../service/UtilService';
export default {
    authService: null,
    utilService: null,
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            email: '',
            submitted: false,
            isProcessing: false,
            isError: false,
            isRequestSuccess: false,
            errorMsg: '',
        };
    },
    created() {
        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
        this.authService = new AuthService();
        this.utilService = new UtilService();

        let user = this.$loadUserData(this);
        if (user) {
            this.$gotoProfile(this);
        }
    },
    validations() {
        return {
            email: {
                required,
            },
        };
    },
    methods: {
        async sendResetPasswordRequest() {
            try {
                this.isProcessing = true;
                this.isError = false;
                this.submitted = true;
                let response = await this.authService.sendPasswordResetRequestByEmail(this.email.toLocaleLowerCase().trim());
                this.utilService.consoleLog('response:', response);
                this.isRequestSuccess = true;
            } catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
                if (errObject.errorDescription) {
                    this.errorMsg = errObject.errorDescription;
                } else {
                    this.errorMsg = 'Error occurred while processing request! Please try again later.';
                }
                this.isError = true;
                this.isRequestSuccess = false;
            } finally {
                this.isProcessing = false;
                this.submitted = false;
            }
        },
        resetForm() {
            this.email = '';
            this.password = '';
        },
        togglePasswordInputType() {
            if (this.showPasswordFlag) {
                this.showPasswordFlag = false;
                this.passwordInputType = 'password';
            } else {
                this.showPasswordFlag = true;
                this.passwordInputType = 'text';
            }
        },
        gotoShop() {
            this.$gotoShop(this);
        },
        gotoEmailResetCodeRequest() {
            this.$gotoPasswordResetCodeEmailRequest(this);
        },
        gotoPhoneResetCodeRequest() {
            this.$gotoPasswordResetCodePhoneRequest(this);
        },
        gotoPasswordResetWithEmail() {
            this.$gotoResetPasswordWithEmail(this);
        },
        gotoPasswordResetWithPhone() {
            this.$gotoResetPasswordWithPhone(this);
        },
        gotoRegistry() {
            this.$gotoAccountRegistry(this);
        },
    },
};
</script>

<style lang="scss" scoped>
.password-input-text-corner {
    border-radius: 3px 0 0 3px !important;
    border-width: 1px 0 1px 1px !important;
}

.password-input-btn-corner {
    border-radius: 0 3px 3px 0;
    border-width: 1px 1px 1px 0;
    border-color: #65656a;
}

.login-body {
    overflow: hidden;
    position: relative;
    background: url('https://stc-content.ackaya.com/_exp_content/yuzaner/common/images/digital-bg1.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 150vh;
    padding: 0;
    margin: 0;
}

.login-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
a {
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}

.input-group-button {
    margin-top: 0em !important;
    display: block;
    min-width: auto !important;
}

.login-body .login-panel {
    background-color: rgba(255, 255, 255, 0.9);
    opacity: 0.95;
}

@media screen and (max-width: 40em) {
    .login-body {
        height: 180vh;
    }

    .login-body .login-panel {
        background-color: rgba(255, 255, 255, 0.9);
        opacity: 0.95;
        height: 100%;
    }
}
</style>
